import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import { matchPath } from 'react-router-dom';
import { Nav, NavItem, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { string, object, func, oneOfType, array } from 'prop-types';

class CardHeaderNav extends PureComponent {
  static propTypes = {
    tag: oneOfType([func, string]),
    className: string,
    navLinks: array,
    navClasses: string,
    innerRef: oneOfType([object, func, string]),
  };

  static defaultProps = {
    tag: 'div',
    navClasses: 'col-12',
    navLinks: [],
  };

  state = {
    dropdownOpen: false,
    dropdownTitle: '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { navLinks } = nextProps;

    if (navLinks.length > 0) {
      this.setState(() => ({
        dropdownTitle: navLinks[0].props.title,
      }));
    }
    let navTitle = null;
    if (navLinks.length > 0) {
      navLinks.forEach((link) => {
        if (this.matchLinkPath(link)) {
          navTitle = link.props.title;
        }
      });
    }

    navTitle &&
      this.setState(() => ({
        dropdownTitle: navTitle,
      }));
  }

  componentDidMount() {
    const { navLinks } = this.props;
    let navTitle = null;

    if (navLinks.length > 0) {
      navLinks.forEach((link) => {
        if (this.matchLinkPath(link)) {
          navTitle = link.props.title;
        }
      });
    }

    navTitle &&
      this.setState(() => ({
        dropdownTitle: navTitle,
      }));
  }

  renderControls = (navLinks) => {
    const { navClasses } = this.props;

    return (
      navLinks.length > 0 && (
        <Nav className={cn(navClasses, 'nav-tabs_big')}>
          {navLinks.map((navLink) => (
            <NavItem key={navLink.props.title}>{navLink}</NavItem>
          ))}
        </Nav>
      )
    );
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  renderAdditionalControls = () => {
    const { controls } = this.props;
    return controls && <div className="text-right additional-controls">{controls}</div>;
  };

  renderDropdown = (navLinks) => {
    const { navClasses } = this.props;

    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggleDropdown}
        className={cn(navClasses, 'nav-tabs-collapse')}
      >
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={this.state.dropdownOpen}
          className="dropdown-toggle"
        >
          {this.props.dropdownTitle ? this.props.dropdownTitle : this.state.dropdownTitle}
        </DropdownToggle>
        <DropdownMenu>
          {navLinks.length > 0 &&
            navLinks.map((navLink) => (
              <DropdownItem tag="span" key={navLink.props.title} className="no-padding">
                {navLink}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    );
  };

  matchLinkPath = (link) => {
    const {
      to: { pathname },
      exact,
      strict,
    } = link.props;

    const isMatch = matchPath(window.location.pathname, {
      path: pathname,
      exact: exact,
      strict: strict,
    });

    return !!isMatch;
  };

  render() {
    const {
      navLinks,
      className,
      navClasses,
      children,
      innerRef,
      loading,
      tag: Tag,
      dropdownTitle,
      ...attributes
    } = this.props;

    return (
      <Tag
        className={cn(className, 'card-header d-flex no-padding')}
        ref={innerRef}
        {...attributes}
      >
        <div className="navlinks-controls">
          {this.renderControls(navLinks)}
          {this.renderDropdown(navLinks)}
          {!loading && this.renderAdditionalControls()}
        </div>
        {children}
      </Tag>
    );
  }
}

const mapStateToProps = ({ webmaster: { profile } }) => ({ profile });

export default CardHeaderNav;
